var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconViewDocuments = function SvgIconViewDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -246) translate(333 246.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "#1A171B"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M8.656.203H3.965v.912h4.691c.163 0 .297.128.297.285v3.968L8.928 11.9c0 .158-.133.286-.297.286H3.965v.912H8.63c.687 0 1.246-.536 1.246-1.197l.025-10.5c0-.66-.559-1.198-1.246-1.198",
    transform: "translate(4 4) translate(2.933 1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M5.202 3.638h-2.83c-.263 0-.475-.204-.475-.456 0-.251.212-.456.475-.456h2.83c.262 0 .474.205.474.456 0 .252-.212.456-.474.456M2.129 4.8l3.423-.004c.13 0 .237-.102.237-.228s-.107-.228-.238-.228l-3.423.004c-.131 0-.237.102-.237.228s.106.228.238.228m0 .863l3.423-.004c.13 0 .237-.102.237-.228 0-.127-.107-.228-.238-.228l-3.423.004c-.131 0-.237.102-.237.228s.106.228.238.228m0 .943l2.388-.003c.131 0 .237-.104.237-.23 0-.125-.106-.227-.237-.227l-2.389.004c-.131 0-.237.102-.237.228s.106.228.238.228m6.332 6.037c0-.253-.213-.457-.475-.457H1.314c-.164 0-.297-.128-.297-.286L.992 5.369V1.4c0-.158.134-.286.296-.286h7.368c.164 0 .296.128.296.286v1.896c0 .252.213.456.476.456.261 0 .474-.204.474-.456V1.401C9.902.74 9.343.203 8.656.203H1.288C.602.203.043.74.043 1.4l.025 10.5c0 .66.559 1.198 1.246 1.198h6.672c.262 0 .475-.205.475-.456",
    transform: "translate(4 4) translate(2.933 1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M4.265 10c0 .662-.537 1.2-1.199 1.2s-1.2-.538-1.2-1.2c0-.663.538-1.2 1.2-1.2.662 0 1.2.537 1.2 1.2",
    transform: "translate(4 4) translate(2.933 1.333)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconViewDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_view_documents.c95b0570.svg";
export { ForwardRef as ReactComponent };